<script setup lang="ts">
import { Link, useForm } from "@inertiajs/vue3"
import { useNotifications } from "@/composables/useNotifications"

const props = defineProps<{
  errors?: Record<string, string[]>
  role_keys: string[]
}>()

const form = useForm({
  company: {
    name: "",
    cnpj: "",
  },
  first_user: {
    name: "",
    email: "",
    role_key: "company_admin",
  },
})

const notify = useNotifications()
const fieldError = (field: string) => props.errors?.[field]?.[0]

function submit() {
  form.post("/backoffice/companies", {
    onSuccess: () => notify.success("Empresa criada e convite enviado com sucesso"),
  })
}
</script>

<template>
  <main class="mx-auto max-w-3xl px-6 py-10">
    <h1 class="text-2xl font-semibold text-slate-900">Nova empresa</h1>
    <p class="mt-2 text-sm text-slate-600">Cria a empresa e envia o primeiro convite de acesso.</p>

    <form class="mt-6 space-y-5 rounded border border-slate-200 bg-white p-6 shadow-sm" @submit.prevent="submit">
      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="company_name">Nome da empresa</label>
        <input id="company_name" v-model="form.company.name" required type="text" class="w-full rounded border border-slate-300 px-3 py-2" />
        <p v-if="fieldError('name')" class="mt-1 text-sm text-rose-600">{{ fieldError('name') }}</p>
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="company_cnpj">CNPJ (opcional)</label>
        <input id="company_cnpj" v-model="form.company.cnpj" type="text" class="w-full rounded border border-slate-300 px-3 py-2" />
        <p v-if="fieldError('cnpj')" class="mt-1 text-sm text-rose-600">{{ fieldError('cnpj') }}</p>
      </div>

      <hr />

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="first_user_name">Primeiro usuario - nome</label>
        <input id="first_user_name" v-model="form.first_user.name" required type="text" class="w-full rounded border border-slate-300 px-3 py-2" />
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="first_user_email">Primeiro usuario - e-mail</label>
        <input id="first_user_email" v-model="form.first_user.email" required type="email" class="w-full rounded border border-slate-300 px-3 py-2" />
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="first_user_role">Role inicial</label>
        <select id="first_user_role" v-model="form.first_user.role_key" class="w-full rounded border border-slate-300 px-3 py-2">
          <option v-for="roleKey in props.role_keys" :key="roleKey" :value="roleKey">
            {{ roleKey }}
          </option>
        </select>
      </div>

      <div class="flex gap-3">
        <button type="submit" :disabled="form.processing" class="rounded bg-indigo-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-60">
          Criar empresa e convidar
        </button>
        <Link href="/" class="rounded border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700">Voltar</Link>
      </div>
    </form>
  </main>
</template>
